export default __webpack_public_path__ + "static/media/UUnlimited-Logo.233af925.png";